// @ts-check

/**
 * @readonly
 * @enum {string}
 */
const TripType = {
  ONE_WAY: "oneway",
  ROUND_TRIP: "roundtrip",
  i18n_one_way_key: "trip_types.one_way",
  i18n_round_trip_key: "trip_types.round_trip",
};

export { TripType };
